import { useScopePanel } from '~/composables/web-chat/useScopePanel'
import { scopeAllowList } from '~~/shared/web-chat/scopeLadder'

/**
 * Restore the remembered chat scope once per session, from the app shell.
 *
 * **This used to run in `ChatScopeBar`'s `onMounted`, which made it invisible on browsing pages.**
 * The composer is not mounted while the docked chat is collapsed, so a user who had a case selected
 * yesterday landed on `/app/cases` unscoped and with no context rail — and then watched the rail pop
 * open the moment they clicked the chat bubble, because THAT is when the restore finally ran.
 * Restoring is a property of the session, not of one component being on screen, so it belongs where
 * the rail does: `PanelLayout`, mounted on every `/app` route.
 *
 * The allow-list step is the load-bearing part and is unchanged. `ensureScopeLists()` is the
 * session's single auth-aware fetch; only a load we KNOW succeeded may publish the ids, because a
 * failed fetch yields empty lists indistinguishable from "this org has nothing", and the store would
 * take that as licence to forget the remembered scope. Idempotent: `ensureScopeLists` caches, and
 * `applyRememberedScope` no-ops once a scope or a conversation exists.
 *
 * The allow-list itself is `scopeAllowList` in `shared/web-chat/scopeLadder.ts`, beside the rules
 * that build the picker's columns — the client ids come from the CLIENT LIST now, and that file says
 * why (AlexAmin/marcus#85).
 */
export function useRestoreScope() {
  const webChat = useWebChatStore()
  const { clients, cases, ensureScopeLists } = useScopePanel()

  onMounted(async () => {
    if (!await ensureScopeLists()) return
    webChat.setKnownScopeIds(scopeAllowList(clients.value, cases.value))
    webChat.applyRememberedScope()
  })
}
